// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Footer-module--cds--assistive-text--6213e";
export var cdsVisuallyHidden = "Footer-module--cds--visually-hidden--20fdd";
export var content = "Footer-module--content--e1f0b";
export var footer = "Footer-module--footer--b2934";
export var grid = "Footer-module--grid--f0d45";
export var hideFeedback = "Footer-module--hide-feedback--36ad3";
export var listItem = "Footer-module--listItem--023ef";
export var logo = "Footer-module--logo--ce22d";
export var nav = "Footer-module--nav--420c2";
export var showFeedback = "Footer-module--show-feedback--9a840";
export var skeleton = "Footer-module--skeleton--cb91c";